module.exports = __webpack_public_path__ + "static/img/WW.9949dbb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/SuperAce/WW.png
// module id = A1wA
// module chunks = 0